module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/6mill-active-11d4cbfda7ec589f31ebb3c2c1e7ed4c.png";